import React from "react"

const Check = ({ className }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		className={`w-30 h-30 fill-current ${className || ""}`}
		viewBox="0 0 30 30">
		<path d="M9.27 13.749l4.1 4.113L21.234 10l1.768 1.768-9.636 9.632L7.5 15.513l1.77-1.764zM15 27.5c6.905 0 12.5-5.596 12.5-12.5 0-6.905-5.596-12.5-12.5-12.5C8.095 2.5 2.5 8.096 2.5 15c0 6.905 5.596 12.5 12.5 12.5zm0 2.5C6.716 30 0 23.286 0 15 0 6.716 6.714 0 15 0c8.284 0 15 6.714 15 15 0 8.284-6.714 15-15 15z" />
	</svg>
)

export default Check
